import { CancellationState } from 'lib/graphql';
import { getBookingCancellationQuotePageLink } from 'lib/links';

export const getPathNameForStage = (bookingId: string, stage: CancellationState, error?: Error) => {
  const suffix = getStageSuffix(stage, error);
  return getBookingCancellationQuotePageLink(bookingId, suffix);
};

const getStageSuffix = (stage: CancellationState, error?: Error) => {
  switch (true) {
    case !!error:
    case stage === 'FAILED':
    case stage === 'BLOCKED':
    case stage === 'INVALID':
      return '/error';
    case stage === 'ACCEPTED':
      return '/confirmed';
    case stage === 'ACCEPTING':
      return '/submitting';
    case stage === 'QUOTED':
      return '/review';
    default:
      return '';
  }
};
